// YOOOOO! this is from the sso project and i modified it a bit because it didn't fully
// work with angular, so, idk, just a heads-up or something

// @todo verify browser compatibility with older browsers
// @todo Add node unit tests

import {jwtDecode} from "jwt-decode"

var Config = null;
//import * as Config from "./securlyplatform.config.js"

// We'll cache the public key here
var PublicKey = null;
var ClientId = null;

// Set the OauthClientId
export async function Init(_ClientId, Issuer) {
  ClientId = _ClientId;

  Config = await (await fetch(`${Issuer}/.well-known/openid-configuration`)).json();

  return Config;
}

// Returns a Promise.  If successful that promise will return a json object with authentication
// details from the JWT token.   Otherwise a status string.
export async function Identify() {
  var token;

  var use_cache = true;
  var use_securly_transparent = true;

  // Parse Debug Flags
  var q = parseQueryString();
  if (typeof q.sp_no_cache !== "undefined") {
    console.log("Disabling JWT Identity caching...")
    use_cache = false;
  }

  if (typeof q.sp_no_trans !== "undefined") {
    console.log("Disabling Securly Transparent Flow OIDC Extension...")
    use_securly_transparent = false;
  }

  // Always try to Get the token by processing url parameters if they are present
  token = await oidcIdentify();
  
  if (token && await verifyToken(token)) {
    cacheToken(token);
    console.log("Securly Token Grant from Code Flow");
    // Refresh the page to the clean URL (pathname only, no parameters)
    window.location.href = window.location.pathname;
    return jwtDecode(token);
  }

  // Try to get the token out of the cache
  // @todo once single log out and introspection is written, validate at the introspection endpoint every five minutes
  if (use_cache) {
    token = cacheIdentify();
    if (token && await verifyToken(token)) {
      console.log("Securly Token Grant from Cache");
      return jwtDecode(token);
    }

    // Bad token in cache
    if (token != null)
      cacheClear();
  }

  // Try to get the token from the securly extensions
  if (use_securly_transparent) {
    token = await securlyIdentify();
    if (token && await verifyToken(token)) {
      console.log("Securly Token Grant from Securly Extensions");
      cacheToken(token);
      return jwtDecode(token);
    }
  }

  throw "No valid token found";
}

// Executes a top level navigation that results in the user being logged in.
// @param redirect_uri is where the system should return after login, often just 'window.location'
// @param force_auth_mech An optional parameter that can be set to 'google' to skip the securly ui and force google auth
export function Login(redirect_uri, force_auth_mech) {
  localStorage.setItem("redirect_uri", redirect_uri)

  // Create and store a random "state" value
  var state = generateRandomString();
  localStorage.setItem("pkce_state", state);

  // Create and store a new PKCE code_verifier (the plaintext random secret)
  var code_verifier = generateRandomString();
  localStorage.setItem("pkce_code_verifier", code_verifier);

  var force_auth_mech_param = ""
  if (typeof force_auth_mech !== undefined) {
    force_auth_mech_param = "&force_auth_mech=" + force_auth_mech
  }

  // Hash and base64-urlencode the secret to use as the challenge
  pkceChallengeFromVerifier(code_verifier).then((code_challenge) => {
    // Build the authorization URL
    var url = Config.authorization_endpoint
      + "?response_type=code"
      + "&client_id=" + encodeURIComponent(ClientId)
      + "&state=" + encodeURIComponent(state)
      + "&scope=" + encodeURIComponent("openid email")
      + "&redirect_uri=" + encodeURIComponent(redirect_uri)
      + "&code_challenge=" + encodeURIComponent(code_challenge)
      + "&code_challenge_method=S256"
      + force_auth_mech_param
    ;

    // Redirect to the authorization server
    window.location = url;
  });
}

// Returns a Promise.
export async function Logout() {
  cacheClear();

  await fetch(`${Config.issuer}/logout`, {
    credentials: 'include'
  });
}

export function Token() {
  return cacheIdentify();
}

/**************************************
 * Helper functions below this line
 **************************************/

// Gets the token from localStorage only
function cacheIdentify() {
  return localStorage.getItem("securly_token");
}

// Save the token in localStorage only
function cacheToken(token) {
  localStorage.setItem("securly_token", token);
}

// Remove the token from the cache
function cacheClear() {
  localStorage.removeItem("securly_token");
}

// Tries to get a JWT token from the code and state parameters in the url if
// they are present.  Returns a promsie for a JWT token or null
async function oidcIdentify() {
  var q = parseQueryString();
  if (!q.state || !q.code) {
    return Promise.resolve(null) // Not a bug, normal
  }

  var expected_state = localStorage.getItem("pkce_state");
  if (expected_state != q.state) {
    return Promise.resolve(null);
  }

  try {
    var ret = await fetch(Config.token_endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: form_urlencoded({
        grant_type: "authorization_code",
        code: q.code,
        client_id: ClientId,
        redirect_uri: localStorage.getItem("redirect_uri"),
        code_verifier: localStorage.getItem("pkce_code_verifier")
      })
    });
    
    if (!ret.ok) {
      const errorText = await ret.text();
      console.error("Token exchange failed:", ret.status, errorText);
      return null;
    }

    const response = await ret.json();
    return response.id_token;

  } catch (error) {
    console.error("Error in oidcIdentify():", error);
    return null;
  }
}

// Uses the Securly Extension to check for an JWT token from our cookie or from
// the central system.   Returns a promise for a JWT token or a string error
async function securlyIdentify() {
  try {
    var ret = await fetch(Config.token_endpoint, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: form_urlencoded({
        grant_type: "securly_transparent",
        client_id: ClientId
      })
    });

    return (await ret.json()).id_token;
  } catch (error) {
    return ("Logged Out");
  }
}

async function verifyToken(token) {
  if (token == null)
    return false;

  // Verify the token using the introspection endpoint
  var isValid = false;
  try {
    var ret = await fetch(Config.introspection_endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: form_urlencoded({
        token: token
      })
    });

    var introspection = await ret.json();

    if (introspection.active) {
      isValid = true;
    }
  } catch (error) {
    return false;
  }
  return isValid;
}

export async function revokeToken(token) {
  if (token == null)
    return;

  // Revoke the token using the revocation endpoint
  try {
    var ret = await fetch(Config.revocation_endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: form_urlencoded({
        token: token
      })
    });

    var revoke = await ret.json();
    if (revoke.status === "Success") {
      cacheClear();
      window.location.reload();
    }
  } catch (error) {
    return;
  }
  return;
}

async function asyncXmlHttpRequest(method, url) {
  return new Promise(function (resolve, reject) {
    let xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve(xhr.response);
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText
        });
      }
    };
    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText
      });
    };
    xhr.send();
  });
}

// Generate a secure random string using the browser crypto functions
function generateRandomString() {
  var array = new Uint32Array(28);
  window.crypto.getRandomValues(array);
  return Array.from(array, dec => ('0' + dec.toString(16)).substr(-2)).join('');
}

// Calculate the SHA256 hash of the input text.
// Returns a promise that resolves to an ArrayBuffer
function sha256(plain) {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest('SHA-256', data);
}

// Base64-urlencodes the input string
function base64urlencode(str) {
  // Convert the ArrayBuffer to string using Uint8 array to convert to what btoa accepts.
  // btoa accepts chars only within ascii 0-255 and base64 encodes them.
  // Then convert the base64 encoded to base64url encoded
  //   (replace + with -, replace / with _, trim trailing =)
  return btoa(String.fromCharCode.apply(null, new Uint8Array(str)))
    .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

// Return the base64-urlencoded sha256 hash for the PKCE challenge
function pkceChallengeFromVerifier(v) {
  var myPromise = sha256(v).then((hashed) => {
    return base64urlencode(hashed);
  });

  return myPromise;
}

// Parse a query string into an object
function parseQueryString() {
  var string = window.location.search.substring(1)

  if (string == "") {
    return {};
  }

  var segments = string.split("&").map(s => s.split("="));
  var queryString = {};
  segments.forEach(s => queryString[s[0]] = s[1]);
  return queryString;
}

function form_urlencoded(data) {
  var ret = [];

  for (var key in data) {
    var encoded_key = encodeURIComponent(key);
    var encoded_value = encodeURIComponent(data[key]);
    ret.push(`${encoded_key}=${encoded_value}`);
  }

  ret = ret.join("&");

  return ret;
}